import React from "react";

import PointsPill from "./PointsPill";
import CoinsPill from "./CoinsPill";

type Rank =
  | "Beginner"
  | "Youngling"
  | "Padawan"
  | "Knight"
  | "Master"
  | "Yellowbelt"
  | "Redbelt"
  | "Greenbelt"
  | "Bluebelt"
  | "Blackbelt";

type BadgeRowProps = {
  rank?: Rank | null;
  pointsEarned?: number;
  coins?: number;
  system?: "jedi" | "karate";
};

const FALLBACK_BADGE = "/badges/sprout-getting-started.png";

const badgeMap: Partial<Record<Rank, string>> = {
  Beginner: FALLBACK_BADGE,
  Youngling: "/badges/jedi-youngling-cropped.png",
  Padawan: "/badges/jedi-padawan-cropped.png",
  Knight: "/badges/jedi-knight-cropped.png",
  Master: "/badges/jedi-master-cropped.png",
  Yellowbelt: "/badges/karate-yellobelt.png",
  Redbelt: "/badges/karate-redbelt.png",
  Greenbelt: "/badges/karate-greenbelt.png",
  Bluebelt: "/badges/karate-bluebelt.png",
  Blackbelt: "/badges/karate-blackbelt.png",
};

const BadgeRow: React.FC<BadgeRowProps> = ({
  rank,
  pointsEarned = 0,
  coins = 0,
  system,
}) => {
  const prefix =
    !rank || rank === "Beginner"
      ? ""
      : system === "jedi"
      ? "Jedi"
      : system === "karate"
      ? "Karate"
      : "Rank";

  const badgeSrc = rank
    ? badgeMap[rank] || FALLBACK_BADGE
    : null;

  const altText =
    !rank
      ? ""
      : rank === "Beginner"
      ? "Getting Started badge"
      : `${prefix} ${rank} badge`;

  return (
    <section className="w-full mt-3 mb-0">
      <div className="grid grid-cols-3 items-center">
        <div /> {/* left spacer keeps the badge centered */}

        <div className="flex justify-center">
          {rank && badgeSrc ? (
            <img
              src={badgeSrc}
              alt={altText}
              className="h-10 object-contain"
            />
          ) : null}
        </div>

        <div className="flex justify-end items-center gap-4 pr-6 sm:pr-6 lg:pr-8">
          {/* Points: green pill */}
          <PointsPill points={pointsEarned} />

          {/* Coins: gold pill, same size + layout */}
          <CoinsPill coins={coins} />
        </div>
      </div>
    </section>
  );
};

export default BadgeRow;